<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page @page:afterin="afterin" @page:beforeout="beforeOut">
    <template v-if="optionId">
      <f7-navbar :title="`${optionTitle}: 選項內容編輯`" back-link="back">
        <f7-nav-right>
          <f7-link @click="onDeleteOption({ questionId, optionId, index: optionIndex, elementLevel })">
            <font-awesome-icon icon="trash" />
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <element-path :path="currentElementPath" />
      <f7-list v-if="question.type !== 'switch'" style="margin: 0px 0px 0px 0px;">
        <f7-list-item inline-label ref="title">
          <f7-label>選項內容:</f7-label>
          <f7-input type="text" :value="option.title" @input="updateProperties('title', $event.target.value)" @focus="onFocus('title')" clear-button />
        </f7-list-item>
        <f7-list-item inline-label ref="price">
          <f7-label>選項內容價錢:</f7-label>
          <f7-input type="number" placeholder="ex. 5.5" :value="parseFloat(option.price)" @input="updateProperties('price', isNaN(parseFloat($event.target.value)) ? 0 : parseFloat($event.target.value))" @focus="onFocus('price')" clear-button />
        </f7-list-item>
      </f7-list>
      <f7-list
        v-if="question.type !== 'switch'">
        <f7-list-item title="站點" group-title></f7-list-item>
        <f7-list-item
          checkbox
          v-for="(workStation, key) in workStationList"
          :key="`workStation-${key}`"
          :checked="optionKitchenStationId[workStation.id] ? true : false"
          :title="workStation.id"
          @change="onWorkStationSelectChanged($event.target.checked, workStation.id, option.itemId)">
        </f7-list-item>
      </f7-list>
      <f7-list
        v-if="questions"
        sortable
        :sortable-enabled="true"
        @sortable:sort="onQuestionSort($event.detail.from - 1, $event.detail.to - 1)"
        no-hairlines-between
        style="margin: 0px 0px 0px 0px;">
        <template v-if="pathLength === 5 && question.type !== 'numberGroup'">
          <f7-list-item group-title title="下層選項" />
          <f7-list-item
            v-for="(question, index) in questions"
            :key="`menu-drafts-questions-edit-${index}`"
            @click="showQuestionActions(question.id, index)">
            <span slot="title">
              {{ index + 1 }}. {{ question.title }}: ({{ $t(`questionType.${question.type}`) }})
            </span>
            <font-awesome-icon slot="after" icon="edit" style="color: #4CAF50; margin-right: 10px;" />
          </f7-list-item>
          <f7-button
            fill
            raised
            :href="`/stores/${storeIdProp}/menu-drafts/${menuDraftVariationProp}/create-question-actions`"
            style="margin: 10px 10%;">
            新增選項
          </f7-button>
        </template>
      </f7-list>
    </template>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ElementPath from '@/components/ElementPath'
import * as R from 'ramda'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      pathLength: 0,
      workStationList: [],
      relatedWorkStationList: []
    }
  },
  async created () {
    this.pathLength = this.currentElementPath.length
    const { data: workStationList } = await storeClient.get(`stores/${this.storeIdProp}/kitchenStations`)
    this.workStationList = workStationList
  },
  computed: {
    ...mapState(['storeId']),
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    categoryId () { return this.currentElementPath[0].id },
    groupId () { return this.currentElementPath[1].id },
    itemId () { return this.currentElementPath[2].id },
    parentElementLevel () { return this.pathLength === 7 ? 5 : 3 },
    elementLevel () { return this.pathLength === 7 ? 6 : 4 },
    questionId () { return this.currentElementPath[this.parentElementLevel].id },
    question () { return this.currentDraft.questions[this.questionId] },
    optionId () { return this.currentElementPath[this.elementLevel] ? this.currentElementPath[this.elementLevel].id : null },
    optionIndex () { return this.currentElementPath[this.elementLevel].index },
    option () { return this.currentDraft.options[this.optionId] },
    optionKitchenStationId () { return this.option.kitchenStationId ? this.option.kitchenStationId : {} },
    questions () {
      return this.currentDraft.options[this.optionId].questions
        .map(k => this.currentDraft.questions[k])
    },
    optionTitle () { return this.question.type === 'switch' ? this.question.title : this.option.title }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'setOptionProperties', 'deleteOption']),
    async updateProperties (prop, v) {
      this.setOptionProperties({ questionId: this.questionId, optionId: this.optionId, elementLevel: this.elementLevel, properties: R.assoc(prop, v, {}) })
    },
    async updateIsItem (prop, v) { // 更新是否為商品
      if (v) {
        this.setOptionProperties({ questionId: this.questionId, optionId: this.optionId, elementLevel: this.elementLevel, properties: { isItemOption: true } })
      } else {
        this.setOptionProperties({ questionId: this.questionId, optionId: this.optionId, elementLevel: this.elementLevel, properties: { isItemOption: false } })
      }
    },
    onWorkStationSelectChanged (isChecked, kitchenStationId, itemId) {
      let isItemOption = false
      let relates = Object.assign({}, this.option.kitchenStationId ? this.option.kitchenStationId : {})
      if (isChecked) {
        relates[kitchenStationId] = true
      } else {
        delete relates[kitchenStationId]
      }

      this.workStationList.map(k => {
        if (relates[k.id]) isItemOption = true
      })

      this.setOptionProperties({
        questionId: this.questionId,
        optionId: this.optionId,
        elementLevel: this.elementLevel,
        properties: {
          kitchenStationId: relates,
          isItemOption: isItemOption
        }
      })
    },
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    showQuestionActions (questionId, index) {
      this.setCurrentElementPath(this.currentElementPath.slice(0, this.elementLevel + 1).concat([{ id: questionId, index }]))
      this.$f7router.navigate(`/stores/${this.storeIdProp}/menu-drafts/${this.menuDraftVariationProp}/questions/${questionId}/question-actions`)
    },
    onQuestionSort (from, to) {
      const questionIds = this.option.questions.slice()
      questionIds.splice(to, 0, questionIds.splice(from, 1)[0])
      this.setOptionProperties({ questionId: this.questionId, optionId: this.optionId, elementLevel: this.elementLevel, properties: { questions: questionIds } })
    },
    onDeleteOption ({ questionId, optionId, index, elementLevel }) {
      this.$f7.dialog.confirm(`確定要刪除 ${this.optionTitle} ?`, '刪除選項內容', () => {
        this.deleteOption({ questionId, optionId, index, elementLevel })
        this.$f7router.back()
      })
    },
    afterin () {
      this.setCurrentElementPath(this.currentElementPath.slice(0, this.pathLength))
    },
    beforeOut () {
      this.$f7.dialog.close()
    }
  },
  components: {
    ElementPath
  }
}
</script>
